<template>
  <div class="chat-window">
    <template v-if="!currentSessionId">
      <div v-if="showTab" class="chat-header-tabs">
        <span
          v-for="tab in tabList"
          :key="tab.value"
          class="tab"
          :class="{ active: activeTab === tab.value }"
          @click="handleTabClick(tab)"
          tabindex="0"
          :aria-label="tab.name"
        >
          {{ tab.name }}
          <!-- <span
            v-if="tab.value === 'C2C' && privateUnread > 0"
            class="unread-badge"
            >{{ privateUnread > 99 ? "99+" : privateUnread }}</span
          > -->
        </span>
      </div>
      <div class="tabs-cont-wrap">
        <Group
          v-if="activeTab === 'group'"
          ref="groupComponent"
          :messages="messages"
          :input="input"
          :readonly="readonly"
          @send="handleSend"
          @input-change="handleInputChange"
          :userInfo="userInfo"
          :groupSessionId="groupSessionId"
          :selectedMember="selectedMember"
          @select-member="handleSelectMember"
          @load-more-messages="handleLoadMoreMessages"
          @only-show-teacher="handleOnlyShowTeacher"
          @forbid-click="handleForbidClick"
          @resendMessage="handleResendMessage"
        >
        </Group>
        <ConversationList
          v-if="activeTab === 'C2C'"
          v-show="!currentSessionId"
          @select-conversation="handleSelectConversation"
        />
      </div>
    </template>
    <template v-else>
      <Private
        :messages="messages"
        :input="input"
        :readonly="readonly"
        @send="handleSend"
        @input-change="handleInputChange"
        @load-more-messages="handleLoadMoreMessages"
        @private-back="handlePrivateBack"
        @resendMessage="handleResendMessage"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Group from "./components/Group.vue";
import ConversationList from "./components/ConversationList.vue";
import Private from "./components/Private.vue";
export default {
  props: {
    messages: Array,
    input: String,
    readonly: Boolean,
    tabList: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    onTabClick: {
      type: Function,
      required: true,
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    groupSessionId: {
      type: String,
      default: "",
    },
    selectedMember: {
      type: [Object, String],
      default: "all",
    },
  },
  data() {
    return {
      inputValue: this.input || "",
    };
  },
  computed: {
    ...mapGetters("newChat", ["showTab", "currentSessionId"]),
    ...mapState("newChat", ["privateUnread"]),
  },
  watch: {
    input(val) {
      this.inputValue = val;
    },
  },
  methods: {
    handleResendMessage(message) {
      this.$emit("resendMessage", message);
    },
    handlePrivateBack() {
      this.$emit("private-back");
    },
    handleForbidClick(callback) {
      this.$emit("forbid-click", callback);
    },
    handleOnlyShowTeacher(callback) {
      this.$emit("only-show-teacher", callback);
    },
    handleSend(data) {
      this.$emit("send", data);
    },
    handleInputChange(value) {
      this.$emit("input-change", value);
    },
    handleTabClick(tab) {
      if (this.activeTab !== tab.value) {
        this.onTabClick(tab);
      }
    },
    handleSelectMember(member) {
      this.$emit("select-member", member);
    },
    handleLoadMoreMessages(params, callback) {
      this.$emit("load-more-messages", params, callback);
    },
    handleSelectConversation(conversation) {
      this.$emit("select-conversation", conversation);
    },
  },
  components: {
    Group,
    ConversationList,
    Private,
  },
};
</script>
<style lang="scss" scoped>
.chat-window {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 44px);
  padding-top: 6px;

  .chat-header-tabs {
    display: flex;
    align-items: center;

    .tab {
      font-weight: 500;
      font-size: 14px;
      color: #86909c;
      line-height: 20px;
      padding: 0 4px 8px 4px;
      margin-left: 24px;
      cursor: pointer;
      position: relative;

      &:first-child {
        margin-left: 10px;
      }

      .unread-badge {
        position: absolute;
        top: -7px;
        left: 53px;

        font-weight: 600;
        font-size: 10px;
        color: #ffffff;
        line-height: 1;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 0 3px;
        min-width: 18px;
        height: 18px;
        background: #f53f3f;
        border-radius: 100px 100px 100px 100px;
        border: 2px solid #181818;
      }

      &.active {
        color: #4080ff;
        position: relative;

        &::after {
          position: absolute;
          bottom: 0;
          left: 0;
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          background-color: #4080ff;
        }
      }
    }
  }
  .tabs-cont-wrap {
    flex: 1;
    height: 0;
    & > div {
      height: 100%;
    }
  }
}
</style>
